var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66602 14C4.29935 14 3.98546 13.8694 3.72435 13.6083C3.46324 13.3472 3.33268 13.0333 3.33268 12.6667V4H2.66602V2.66667H5.99935V2H9.99935V2.66667H13.3327V4H12.666V12.6667C12.666 13.0333 12.5355 13.3472 12.2743 13.6083C12.0132 13.8694 11.6993 14 11.3327 14H4.66602ZM11.3327 4H4.66602V12.6667H11.3327V4ZM5.99935 11.3333H7.33268V5.33333H5.99935V11.3333ZM8.66602 11.3333H9.99935V5.33333H8.66602V11.3333Z",
    fill: "#64748B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.06e6127774a0a081296ac464c32aa82a.svg";
export { ForwardRef as ReactComponent };